import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    option1Label: String,
    option2Label: String,
    option3Label: String,
    option4Label: String,
    option1Value: String,
    option2Value: String,
    option3Value: String,
    option4Value: String,
    selectedOption: String,
  }

  connect() {
    this.updateButtons()
  }

  selectOption1() {
    this.selectedOptionValue = 'option1'
    this.updateButtons()
    this.updateHiddenField()
    this.dispatchChangeEvent()
  }

  selectOption2() {
    this.selectedOptionValue = 'option2'
    this.updateButtons()
    this.updateHiddenField()
    this.dispatchChangeEvent()
  }

  selectOption3() {
    this.selectedOptionValue = 'option3'
    this.updateButtons()
    this.updateHiddenField()
    this.dispatchChangeEvent()
  }

  selectOption4() {
    this.selectedOptionValue = 'option4'
    this.updateButtons()
    this.updateHiddenField()
    this.dispatchChangeEvent()
  }

  updateButtons() {
    const baseClasses = 'flex items-center justify-center p-2 rounded-lg flex-1'
    const selectedClasses = `${baseClasses} bg-white`

    // Find all option buttons within this controller's scope
    const option1Button = this.element.querySelector('[data-toggle-option-param="option1"]')
    const option2Button = this.element.querySelector('[data-toggle-option-param="option2"]')
    const option3Button = this.element.querySelector('[data-toggle-option-param="option3"]')
    const option4Button = this.element.querySelector('[data-toggle-option-param="option4"]')

    // Reset all buttons to base classes
    if (option1Button) {
      option1Button.className =
        this.selectedOptionValue === 'option1' ? selectedClasses : baseClasses
    }
    if (option2Button) {
      option2Button.className =
        this.selectedOptionValue === 'option2' ? selectedClasses : baseClasses
    }
    if (option3Button) {
      option3Button.className =
        this.selectedOptionValue === 'option3' ? selectedClasses : baseClasses
    }
    if (option4Button) {
      option4Button.className =
        this.selectedOptionValue === 'option4' ? selectedClasses : baseClasses
    }
  }

  updateHiddenField() {
    const hiddenField = this.element.querySelector("input[type='hidden']")
    if (hiddenField) {
      let value
      switch (this.selectedOptionValue) {
        case 'option1':
          value = this.option1ValueValue
          break
        case 'option2':
          value = this.option2ValueValue
          break
        case 'option3':
          value = this.option3ValueValue
          break
        case 'option4':
          value = this.option4ValueValue
          break
        default:
          value = this.option1ValueValue
      }
      hiddenField.value = value
    }
  }

  dispatchChangeEvent() {
    let label, value
    switch (this.selectedOptionValue) {
      case 'option1':
        label = this.option1LabelValue
        value = this.option1ValueValue
        break
      case 'option2':
        label = this.option2LabelValue
        value = this.option2ValueValue
        break
      case 'option3':
        label = this.option3LabelValue
        value = this.option3ValueValue
        break
      case 'option4':
        label = this.option4LabelValue
        value = this.option4ValueValue
        break
      default:
        label = this.option1LabelValue
        value = this.option1ValueValue
    }

    const event = new CustomEvent('toggle:change', {
      detail: {
        selectedOption: this.selectedOptionValue,
        label: label,
        value: value,
      },
      bubbles: true,
    })
    this.element.dispatchEvent(event)
  }
}
